import * as THREE from 'three';

export interface NormalizeParams {
  x: number;
  y: number;
  z: number;
  fitScale: number;
}

/**
 * Reparent all children into an offset wrapper group so the model's
 * visual center sits at its local origin. Optionally scales the model
 * to fit within a 1-unit XZ footprint.
 *
 * Transform order (Three.js): Translate * Scale, so:
 *   finalPos = wrapper.position + wrapper.scale * childPos
 *
 * After this call, `model.position.set(x, 0, z)` places the visual
 * XZ center at (x,z) with the bottom of the mesh at Y=0.
 */
export function normalizeOrigin(
  model: THREE.Group,
  params: NormalizeParams
): void {
  if (model.children.length === 0) return;
  const wrapper = new THREE.Group();
  while (model.children.length > 0) {
    wrapper.add(model.children[0]);
  }
  wrapper.scale.setScalar(params.fitScale);
  wrapper.position.set(params.x, params.y, params.z);
  model.add(wrapper);
}
